import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import {ButtonRaw} from '@/components/Button';
import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import PopupSticked from '@/components/Popup/PopupSticked';
import useIsDesktopOnlyLayout from '@/hooks/layout/useIsDesktopOnlyLayout';
import amplitudeModalsTracking from '@/services/analytics/amplitude/amplitudeModalsTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import appContent from '@/services/content/appContent';
import deviceConnectionService from '@/services/device/deviceConnectionService';
import {hideModalAction} from '@/state/slices/modalSlice';

const ConnectionSelectionPopup = ({modalType, deviceType}) => {
    const dispatch = useDispatch();
    const {title, bleIcon, usbIcon} = appContent.getConnectionMethods();
    const isDesktopOnly = useIsDesktopOnlyLayout();

    useEffect(() => {
        amplitudeModalsTracking.trackMaintenancePopupViewed();
        googleAnalyticsService.trackMaintenancePopupViewed();
    }, []);

    const onClose = () => {
        dispatch(hideModalAction(modalType));
    };
    const handleBleClick = () => {
        deviceConnectionService.redirectToBle(deviceType);
        onClose();
    };
    const handleHidClick = () => {
        deviceConnectionService.redirectToHid(deviceType);
        onClose();
    };
    const connectionOptions = [
        {
            id: 'ble',
            icon: bleIcon,
            title: bleIcon?.title,
            description: bleIcon?.description,
            onClick: handleBleClick,
        },
        {
            id: 'hid',
            icon: usbIcon,
            title: usbIcon?.title,
            description: usbIcon?.description,
            onClick: handleHidClick,
        },
    ];

    const orderedOptions = isDesktopOnly
        ? [connectionOptions[1], connectionOptions[0]] // HID, BLE
        : [connectionOptions[0], connectionOptions[1]]; // BLE, HID

    return (
        <PopupSticked
            className='flex flex-col rounded-t-xl px-6 pb-8 pt-18 ml:p-8 ml:px-8'
            isCloseVisible
            closeButtonClass='right-6 top-6'
            onClose={onClose}
            aria-label={title}
        >
            <h2 className='mb-0 text-start text-28 ml:mt-12 ml:text-center'>{title}</h2>
            <div className='mt-8 flex flex-col gap-4'>
                {orderedOptions.map(({id, icon, title, description, onClick}) => (
                    <ConnectionSelectionPopupItem
                        key={id}
                        icon={icon}
                        title={title}
                        description={description}
                        onClick={onClick}
                    />
                ))}
            </div>
        </PopupSticked>
    );
};

const ConnectionSelectionPopupItem = ({icon, title, description, onClick}) => {
    return (
        <ButtonRaw
            onClick={onClick}
            className='flex items-center gap-2 rounded-xl border border-solid border-primary-dark-15 bg-primary-dark-5 p-4 ml:bg-secondary'
        >
            <RemoteIconV2 icon={icon} className='shrink-0' />
            <div className='flex flex-col gap-2'>
                <h3 className='text-18 tracking-02'>{title}</h3>
                <p className='text-start tracking-04'>{description}</p>
            </div>
        </ButtonRaw>
    );
};

export default ConnectionSelectionPopup;
